<template>
    <svg @mouseover="hovering = true" @mouseleave="hovering = false" class="icon">
        <use :xlink:href="href" :href="href" :data="href">X</use>
    </svg>
</template>

<script>
import Icon from '@/assets/images/icons.svg'
export default {
    name: 'IconComponent',
    props: {
        icon: { default: null },
        hover: { default: null },
    },

    data() {
        return {
            hovering: false,
        }
    },

    computed: {
        href() {
            let hover = this.hover || this.icon;
            let href = Icon + "#";
            if (this.hovering) {
                return href + hover;
            }
            return href + this.icon;
        }
    },

}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.icon {
    fill: var(--icon-color, var(--text-color));
}
</style>
